export class TaskDocChangeTaskRequest {
  doNo: string;
  changeTaskList: string[];
  changeUser: string;
  taskClassName: string;
  doLockHeader: string | null;

  constructor() {
    this.doNo = "";
    this.changeTaskList = [];
    this.changeUser = "";
    this.taskClassName = "";
    this.doLockHeader = "";
  }
}
